import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createIncidenceReview } from '../../services/incidenceService';

const ReviewForm = ({ incidenceId, currentStatus, onReviewCreated, onCancel }) => {
    const { t } = useTranslation();
    const [newStatus, setNewStatus] = useState(currentStatus || 'pending');
    const [notes, setNotes] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const statusOptions = [
        { value: 'pending', label: t('Pendiente') },
        { value: 'reviewed', label: t('Revisada') },
        { value: 'closed', label: t('Cerrada') },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!notes.trim()) {
            setError(t('Review notes are required'));
            return;
        }

        setSubmitting(true);
        setError(null);

        try {
            const result = await createIncidenceReview(incidenceId, {
                new_status: newStatus,
                notes: notes.trim(),
            });
            if (onReviewCreated) onReviewCreated(result);
        } catch (err) {
            setError(err.message || t('Error creating review'));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="p-2">
            <div className="mb-3">
                <label htmlFor="review-status" className="form-label fw-bold" style={{ fontSize: '0.85rem' }}>
                    {t('Estado')}
                </label>
                <select
                    id="review-status"
                    className="form-select form-select-sm"
                    value={newStatus}
                    onChange={(e) => setNewStatus(e.target.value)}
                    disabled={submitting}
                >
                    {statusOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            </div>

            <div className="mb-3">
                <label htmlFor="review-notes" className="form-label fw-bold" style={{ fontSize: '0.85rem' }}>
                    {t('Notas')}
                </label>
                <textarea
                    id="review-notes"
                    className="form-control form-control-sm"
                    rows={3}
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder={t('Describe the review...')}
                    disabled={submitting}
                    maxLength={1000}
                />
            </div>

            {error && (
                <div className="alert alert-danger p-2 mb-2" role="alert" style={{ fontSize: '0.8rem' }}>
                    {error}
                </div>
            )}

            <div className="d-flex justify-content-end gap-2">
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={onCancel}
                    disabled={submitting}
                >
                    {t('Cancelar')}
                </button>
                <button
                    type="submit"
                    className="btn btn-sm btn-primary"
                    disabled={submitting || !notes.trim()}
                >
                    {submitting ? (
                        <>
                            <span
                                style={{
                                    display: 'inline-block',
                                    width: '0.875rem',
                                    height: '0.875rem',
                                    border: '2px solid currentColor',
                                    borderRightColor: 'transparent',
                                    borderRadius: '50%',
                                    animation: 'spin 0.75s linear infinite',
                                    marginRight: '0.25rem',
                                    verticalAlign: 'text-bottom',
                                }}
                                role="status"
                                aria-hidden="true"
                            />
                            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                            {t('Guardando...')}
                        </>
                    ) : (
                        <>
                            <i className="bi bi-check-lg me-1"></i>
                            {t('Guardar revisión')}
                        </>
                    )}
                </button>
            </div>
        </form>
    );
};

export default ReviewForm;
